<template>
  <div class="first:pt-first-section flex flex-col">
    <div ref="sectionRef">
      <ElementArticleOverviewContent :blok="blok" />
    </div>
    <component
      :is="comps[section.component]"
      v-for="section in blok.sections"
      :key="section._uid"
      :blok="section"
    />
  </div>
</template>
<script setup lang="ts">
import { ISbPluginMetaFields, TemplateArticleOverviewStoryblok } from '@/types';
import SbSection from '@/components/sb-sections/SbSection.vue';
import useSectionTheme from '@/composables/useSectionTheme';
import { ISbPluginThemeColorPicker } from '@/types';

const comps = {
  Section: SbSection,
};
interface Props {
  blok: TemplateArticleOverviewStoryblok;
}
const props = defineProps<Props>();
const sectionRef = ref<HTMLElement | null>(null);
const { observeThemeSection } = useSectionTheme();
const theme = computed(() => {
  const colors = props.blok.backgroundColor as ISbPluginThemeColorPicker;
  return {
    bg: colors.hex,
    text: colors.hexFg,
  };
});
observeThemeSection(sectionRef, theme);
</script>

<style scoped></style>
